import React, { useState, useEffect } from "react";

const Staff = () => {
  const [staff, setStaff] = useState([
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Senior Manager",
      zone: "Pond A",
      status: "present",
      arrivalTime: "06:15",
      currentLocation: "Feeding area",
      activityLevel: "active",
      lastSeen: "2 mins ago",
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Technician",
      zone: "Pond B",
      status: "absent",
      expectedArrival: "08:00",
      lastSeen: "Yesterday 17:45",
      activityLevel: "offline",
    },
    {
      id: 3,
      name: "Vikram Patel",
      role: "Feed Specialist",
      zone: "Pond A",
      status: "present",
      arrivalTime: "06:45",
      currentLocation: "Feed storage",
      activityLevel: "active",
      lastSeen: "30 secs ago",
    },
    {
      id: 4,
      name: "Aisha Desai",
      role: "Quality Control",
      zone: "Pond C",
      status: "present",
      arrivalTime: "07:00",
      currentLocation: "Water testing lab",
      activityLevel: "active",
      lastSeen: "1 min ago",
    },
  ]);

  const [selectedStaff, setSelectedStaff] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setStaff((prev) =>
        prev.map((person) => {
          if (person.status === "present") {
            const random = Math.random();
            let newLocation = person.currentLocation;
            const locations = {
              "Pond A": ["Feeding area", "Aerator station", "Water intake"],
              "Pond B": ["Feed storage", "Testing area", "Monitor station"],
              "Pond C": ["Water testing lab", "Storage room", "Perimeter check"],
            };

            if (random > 0.7) {
              const zoneLocations = locations[person.zone] || [];
              newLocation =
                zoneLocations[
                  Math.floor(Math.random() * zoneLocations.length)
                ] || person.currentLocation;
            }

            return {
              ...person,
              currentLocation: newLocation,
              lastSeen: Math.random() > 0.5 ? "1 min ago" : "30 secs ago",
            };
          }
          return person;
        })
      );
      setLastUpdate(new Date());
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const presentCount = staff.filter((s) => s.status === "present").length;
  const absentCount = staff.filter((s) => s.status === "absent").length;
  const ponds = ["Pond A", "Pond B", "Pond C"];
  const coveredPonds = ponds.filter((pond) =>
    staff.some((s) => s.zone === pond && s.status === "present")
  ).length;
  const coverage = Math.round((coveredPonds / ponds.length) * 100);

  const getStatusColor = (status) => {
    switch (status) {
      case "present":
        return "bg-emerald-50 border-emerald-200 text-emerald-900";
      case "absent":
        return "bg-red-50 border-red-200 text-red-900";
      default:
        return "bg-gray-50 border-gray-200 text-gray-900";
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "present":
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-emerald-100 text-emerald-700 text-xs font-medium rounded">
            ● Present
          </span>
        );
      case "absent":
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-100 text-red-700 text-xs font-medium rounded">
            ✕ Absent
          </span>
        );
      default:
        return null;
    }
  };

  const getActivityBadge = (activity) => {
    switch (activity) {
      case "active":
        return (
          <span className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded font-medium">
            Active
          </span>
        );
      case "idle":
        return (
          <span className="text-xs px-2 py-1 bg-amber-100 text-amber-700 rounded font-medium">
            Idle
          </span>
        );
      case "offline":
        return (
          <span className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded font-medium">
            Offline
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-6 py-5 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Staff Presence</h2>
        <p className="text-sm text-gray-500 mt-1">
          Real-time tracking of {staff.length} team members across 3 ponds
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 px-6 py-5 bg-gray-50 border-b border-gray-200">
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Present
          </span>
          <span className="text-2xl font-bold text-emerald-600 mt-1">
            {presentCount}/{staff.length}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Absent
          </span>
          <span className="text-2xl font-bold text-red-600 mt-1">
            {absentCount}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Pond Coverage
          </span>
          <span className="text-2xl font-bold text-blue-600 mt-1">
            {coverage}%
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Covered Zones
          </span>
          <span className="text-2xl font-bold text-purple-600 mt-1">
            {coveredPonds}/{ponds.length}
          </span>
        </div>
      </div>

      <div className="px-6 py-5">
        <div className="space-y-3">
          {staff.map((person) => (
            <div
              key={person.id}
              onClick={() =>
                setSelectedStaff(
                  selectedStaff?.id === person.id ? null : person
                )
              }
              className={`border rounded-lg p-4 cursor-pointer transition-all ${getStatusColor(
                person.status
              )} ${
                selectedStaff?.id === person.id
                  ? "ring-2 ring-offset-0 ring-blue-400"
                  : "hover:shadow-md"
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-sm font-semibold text-gray-700">
                      {person.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                    <div>
                      <h3 className="font-semibold text-sm">{person.name}</h3>
                      <p className="text-xs opacity-75">{person.role}</p>
                    </div>
                  </div>
                </div>
                {getStatusBadge(person.status)}
              </div>

              <div className="space-y-2 text-sm ml-13">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Zone</span>
                  <span className="font-semibold">{person.zone}</span>
                </div>
                {person.status === "present" && (
                  <>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Location</span>
                      <span className="font-semibold text-xs text-right">
                        {person.currentLocation}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Activity</span>
                      {getActivityBadge(person.activityLevel)}
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Arrival</span>
                      <span className="font-mono text-xs">
                        {person.arrivalTime}
                      </span>
                    </div>
                  </>
                )}
                {person.status === "absent" && (
                  <>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Expected</span>
                      <span className="font-semibold">
                        {person.expectedArrival}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700">Last Seen</span>
                      <span className="font-mono text-xs">
                        {person.lastSeen}
                      </span>
                    </div>
                  </>
                )}
              </div>

              {selectedStaff?.id === person.id && (
                <div className="mt-4 pt-4 border-t border-current border-opacity-20 space-y-2 text-sm ml-13">
                  <div className="flex justify-between">
                    <span className="text-gray-700">Detection</span>
                    <span className="font-semibold text-xs">
                      Person detected by AI
                    </span>
                  </div>
                  {person.status === "present" && (
                    <div className="flex justify-between">
                      <span className="text-gray-700">Last Update</span>
                      <span className="font-mono text-xs">
                        {person.lastSeen}
                      </span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-gray-700">Confidence</span>
                    <span className="font-semibold text-xs">
                      {97 + Math.floor(Math.random() * 3)}%
                    </span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-sm font-semibold text-amber-900 mb-2">
            Alert: No activity in Pond B
          </p>
          <p className="text-xs text-amber-800">
            Priya Sharma (assigned technician) has not checked in. Expected
            arrival: 08:00 AM
          </p>
        </div>
      </div>

      <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 text-xs text-gray-500">
        Last updated: {lastUpdate.toLocaleTimeString()} • Detection confidence:
        98%
      </div>
    </div>
  );
};

export default Staff;